// --for react apps--//
export const SESSION_INFO_ROUTE = "/auth/session";
export const LOGIN_CALLBACK_ROUTE = "/auth/callback/fusionauth";

export const LOGIN_ROUTE = "/auth/login";
export const LOGOUT_ROUTE = "/auth/logout";
export const SIGNOUT_ROUTE = "/auth/signout";
export const SSO_ROUTE = "/auth/sso";
export const CHECK_AUTHENTICATED_SHOPS_ROUTE = "/api/authenticated";
export const isDev = process.env.NODE_ENV === "development";

export const REFRESH_TOKEN_ERROR = "RefreshTokenError";
